import React from 'react';
import { useFavorites } from '../hooks/useFavorites';
import { PageHeader, PageLoading } from '../components/account/PageHeader';
import { UserBadge } from '../components/account/UserBadge';
import { SavedSearches } from '../components/account/SavedSearches';

export default function AccountPage() {
  const { user, pending, favorites, add, remove, signOut } = useFavorites();

  if (pending) return <PageLoading label="Loading…" />;

  return (
    <div className="min-h-screen bg-sand-50" data-testid="account-page">
      <PageHeader widthClass="max-w-4xl" logoutTestId="account-logout" onLogout={signOut} />
      <div className="max-w-4xl mx-auto px-5 py-10">
        <UserBadge user={user} />
        <SavedSearches favorites={favorites} onAdd={add} onRemove={remove} />
      </div>
    </div>
  );
}
